import { QueryResult } from 'react-query';
import { callApi, Controller, useApi, UseApiOptions } from './useApi';

export interface BetreuerWorkDay {
    betrNr: number;
    workYear: number;
    workMonth: number;
    workDay: number;
    planStartTime1: number | null;
    planStopTime1: number | null;
    planStartTime2: number | null;
    planStopTime2: number | null;
    planTotal: number;
    startTime1: number | null;
    startTime1S: string;
    stopTime1: number | null;
    stopTime1S: string;
    break1: number | null;
    break1S: string;
    startTime2: number | null;
    startTime2S: string;
    stopTime2: number | null;
    stopTime2S: string;
    break2: number | null;
    break2S: string;
    actualTotal: number;
    absent: string | null;
    note: string;
    isEdited: boolean;
}

export interface BetreuerWorkDayFilter {
    betrNr?: number;
    workYear?: number;
    workMonth?: number;
    workDay?: number;
}

export function useBetreuerWorkDayOne(
    filter?: BetreuerWorkDayFilter,
    apiOptions?: UseApiOptions<BetreuerWorkDay>,
): QueryResult<BetreuerWorkDay> {
    return useApi<BetreuerWorkDay>(Controller.betreuerWorkDay + '/one', { filter }, apiOptions);
}

export async function updateBetreuerWorkDay(betreuerWorkDay: BetreuerWorkDay): Promise<void> {
    return callApi<void>(Controller.betreuerWorkDay + '/update', { betreuerWorkDay });
}
